/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit, HostListener } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { NbThemeService } from '@nebular/theme';
import { Router } from '@angular/router';
import 'style-loader!angular2-toaster/toaster.css';
import { ToasterConfig} from 'angular2-toaster';
import { AuthService } from './auth/auth.service';
import { AutoLogoutService } from './auth/auto-logout/auto-logout.service';
import { FenetreService } from './@core/utils/fenetre-service';
import { MessagingService } from './messaging.service';


@Component({
  selector: 'ngx-app',
  template: '<toaster-container [toasterconfig]="config"></toaster-container>  <router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  config: ToasterConfig;

  themes = [
    {
      title: 'Light',
      key: 'default',
    },
    {
      title: 'Cosmic',
      key: 'cosmic',
    },
    {
      title: 'Corporate',
      key: 'corporate',
    },
  ];

  constructor(private analytics: AnalyticsService,
              private themeService: NbThemeService,
              private fenetreService: FenetreService,
              private authservice: AuthService,
              private autoLogoutService: AutoLogoutService, /* on charge le service de deconnexion automatique pour qu'il s'instancifie */
              private messagingService: MessagingService,) {
             
    this.themeService.changeTheme(this.themes[0].key);

    this.config = new ToasterConfig({
      positionClass: 'toast-bottom-center', // 'toast-top-full-width', 'toast-bottom-full-width', 'toast-top-left', 'toast-top-center', 'toast-top-right', 'toast-bottom-right', 'toast-bottom-center', 'toast-bottom-left', 'toast-center'
      timeout: 3000,
      newestOnTop: false,
      tapToDismiss: true,
      preventDuplicates: false,
      animation: 'slideUp', // 'fade', 'flyLeft', 'flyRight', 'slideDown', 'slideUp'
      limit: 1, // nombre de toast qui appraissent simultanement
    });


    // on vérifie qu'on sur le fenetre principale avant d'éffectuer cette action
    if (this.fenetreService.findnames(window.name) === null ) {
      // tslint:disable-next-line:no-console
      console.log('suppression des fenêtres popups ouvertes');
      localStorage.removeItem('popup');
    }



  
    // recuperation token firebase
    // this.messagingService.requestPermission();



  }

  ngOnInit(): void {
    // this.analytics.trackPageViews();

    // this.router.navigate(['/auth/sadev/login']);

  }



  @HostListener('window:message', ['$event'])
  onMessage(e) {

    // tslint:disable-next-line:no-debugger
    // debugger;
    /* if (e.origin !== 'http://localhost:4200') { // set your origin
      return false;
    } */

    if (e.data.popup !== undefined) {
      const itemIndex = this.fenetreService.Open.findIndex( elem => elem.name === e.data.popup);
      this.fenetreService.Open.splice(itemIndex, 1);
      this.fenetreService.removename(e.data.popup);
    }

    if (e.data.focus !== undefined) {
     window.focus();
     // alert('popup leaves');
    }

    if (e.data === 'deconnexion' && e.origin !== window.location.href) {
      // window.close();
      // alert('popup leaves');

      // tslint:disable-next-line:no-console
      console.log(e.data);

      this.authservice.logout();

    }

    if (e.data === 'connexion' && e.origin !== window.location.href) {
      // window.close();
      // alert('popup leaves');
      // tslint:disable-next-line:no-console
      console.log(e.data);

      this.authservice.login();
      // this.authservice.token =
    }


  }


}
